import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api_middleware";

// Fetch all organizations
export const fetchOrganizations = createAsyncThunk(
  "organizations/fetchOrganizations",
  async () => {
    const response = await api("organizations/", "GET", undefined, {
      usePixelsApi: true,
    });
    return response;
  }
);

// Fetch a single organization by ID
export const fetchOrganization = createAsyncThunk(
  "organizations/fetchOrganization",
  async (organizationId: string) => {
    const response = await api(
      `organizations/${organizationId}`,
      "GET",
      undefined,
      { usePixelsApi: true }
    );
    return response;
  }
);

// Create a new organization
export interface CreateOrganizationParams {
  name: string;
}

export const createOrganization = createAsyncThunk(
  "organizations/createOrganization",
  async (params: CreateOrganizationParams) => {
    const response = await api(
      "organizations/create-organization",
      "POST",
      {
        name: params.name,
      },
      { usePixelsApi: true }
    );
    return response;
  }
);

// Update organization memory schema config
export interface UpdateMemorySchemaConfigParams {
  organizationId: string;
  restrict_memory_schemas: boolean;
  allowed_schemas: string[];
}

export const updateOrganizationMemorySchemaConfig = createAsyncThunk(
  "organizations/updateMemorySchemaConfig",
  async (params: UpdateMemorySchemaConfigParams) => {
    const response = await api(
      `v1/admin/organizations/${params.organizationId}/memory-schema-config`,
      "PUT",
      {
        restrict_memory_schemas: params.restrict_memory_schemas,
        allowed_schemas: params.allowed_schemas,
      }
    );
    return { organizationId: params.organizationId, ...response };
  }
);

// Update an organization - functionality removed
/*
export interface UpdateOrganizationParams {
  id: string;
  name: string;
}

export const updateOrganization = createAsyncThunk(
  "organizations/updateOrganization",
  async (params: UpdateOrganizationParams) => {
    const response = await api(
      `organizations/${params.id}`,
      "PUT",
      {
        name: params.name,
      },
      { usePixelsApi: true }
    );
    return response;
  }
);
*/
